import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../lib/hook";
import { useForm } from "antd/es/form/Form";
import { ITripPayload } from "../../../../lib/features/trips/trips.constant";
import { FormProps } from "antd/lib";
import dayjs from "dayjs";
import { DatePicker, Form, Input, InputNumber, Modal, Switch } from "antd";
import { localeDateTimePicker } from "../../../../function/datePicker.locale";
import { getDetailTripApi } from "../../../../apis/trip.api";
import { ITrip } from "../../../../models/trip";
import { onUpdateTrip } from "../../../../lib/features/trips/trips.thunk";

interface ModalEditTripProps {
  // Add props here
  visible: boolean;
  onClose: () => void;
  tripId: string;
  onSuccess?: () => void;
}

const ModalEditTrip: React.FC<ModalEditTripProps> = (
  props: ModalEditTripProps
) => {
  const { onClose, visible, tripId } = props;
  const dispatch = useAppDispatch();
  const [trip, setTrip] = useState<ITrip | null>(null);
  const [loading, setLoading] = useState(false);
  const [form] = useForm();
  const onFinish: FormProps<ITripPayload>["onFinish"] = async (values) => {
    setLoading(true);
    const departureAtMidnight = dayjs(values.departureDate)
      .startOf("day")
      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    const payload: ITripPayload = {
      ...values,
      departureDate: String(departureAtMidnight),
    };
    await dispatch(onUpdateTrip({ id: tripId, payload: payload })).then(
      (result) => {
        if (result?.type.includes("fulfilled")) {
          form.resetFields();
          onClose && onClose();
          // call optional success callback so parent can refresh
          props.onSuccess && props.onSuccess();
          setLoading(false);
        }
      }
    );

    setLoading(false);
  };
  const handleGetDetailTrip = async () => {
    if (!tripId) return;
    setLoading(true);
    try {
      const res = await getDetailTripApi(tripId);
      if (res?.data) {
        setTrip(res?.data);
      } else {
        setTrip(null);
      }
    } catch (error) {
      console.error("Error fetching customer detail:", error);
      setTrip(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (visible) {
      handleGetDetailTrip();
      return () => {
        form.resetFields();

        setLoading(false);
      };
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  const handleDateChange = (value: number | null) => {
    if (value && value > 0) {
      form.setFieldValue("numberOfNight", Math.max(value - 1, 0));
    } else {
      form.setFieldValue("numberOfNight", 0);
    }
  };
  return (
    <Modal
      loading={loading}
      title="Cập nhật chuyến đi"
      open={visible}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={loading}
    >
      <Form
        disabled={loading}
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        className="mt-3"
        initialValues={
          trip === null
            ? {}
            : {
                name: trip?.name,
                numberOfDate: trip?.numberOfDate,
                numberOfNight: trip?.numberOfNight,
                departureDate: dayjs(trip?.departureDate),
                isNightDeparture: trip?.isNightDeparture,
              }
        }
      >
        <Form.Item<ITripPayload>
          label="Tên chuyến đi"
          name="name"
          rules={[{ required: true, message: "Mời điền tên chuyến đi" }]}
          style={{ marginBottom: 8 }}
        >
          <Input placeholder="Nhập tên chuyến đi" />
        </Form.Item>

        <Form.Item<ITripPayload>
          label="Số ngày"
          name="numberOfDate"
          rules={[
            { required: true, message: "Vui lòng nhập số ngày" },
            { type: "number", min: 1, message: "Số ngày phải lớn hơn 0" },
          ]}
          style={{ marginBottom: 8 }}
        >
          <InputNumber
            min={1}
            style={{ width: "100%" }}
            onChange={handleDateChange}
          />
        </Form.Item>

        <Form.Item<ITripPayload>
          label="Số đêm"
          name="numberOfNight"
          rules={[
            { required: true, message: "Vui lòng nhập số đêm" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const numDate = getFieldValue("numberOfDate");
                if (value <= numDate) return Promise.resolve();
                return Promise.reject(
                  new Error("Số đêm phải nhỏ hơn hoặc bằng số ngày")
                );
              },
            }),
          ]}
          style={{ marginBottom: 8 }}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item<ITripPayload>
          label="Ngày khởi hành"
          name="departureDate"
          rules={[{ required: true, message: "Vui lòng chọn ngày khởi hành" }]}
          style={{ marginBottom: 8 }}
        >
          <DatePicker
            style={{ width: "100%" }}
            format="DD/MM/YYYY"
            placeholder="Chọn ngày khởi hành"
            locale={localeDateTimePicker as any}
          />
        </Form.Item>
        <Form.Item<ITripPayload>
          label="Khởi hành ban đêm"
          name="isNightDeparture"
          valuePropName="checked"
          style={{ marginBottom: 8 }}
        >
          <Switch checkedChildren="Có" unCheckedChildren="Không" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalEditTrip;
